module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-costume-2-9e99b15ee1d7b2cf4043f13cee17fd57.jpg";